// react library imports
import { CaretDown, CaretUp } from "phosphor-react";
import { useState } from "react";

// style imports
import './Sort.css';

// dummy data
// const data=[
//     "month",
//     "year"
// ]

const Sort = ({data, sort, onchange, keyName}) => {
    // useState for show or hide
    const [show, setShow]=useState(false)
    // useState for sort
    const [value, setValue]=useState(sort || "")

    // handle onchange event
    const handleOnChange=(item)=>{
        setValue(item)
        setShow(false)
        if (onchange) {
            onchange(item)
        }
    }
  return (
    <div className="mues_row_space_between mues_grey_I
    mues_column_gap_4 sort_container"
    onClick={()=>setShow(!show)}>
        <label className="mues_one_line_clamp 
        mues_font_weight_500">{value}</label>
        {show ? <CaretUp className="mues_wrapper_icon"
        weight="fill"/>:<CaretDown className="mues_wrapper_icon" 
        weight="fill"/>}
        {show && <div className="sort_option_container">
            {data.map((item, index)=>(
                <div className="sort_option_field">
                    <p className="mues_row_center 
                    mues_font_weight_500 mues_one_line_clamp"
                    key={index} onClick={()=>handleOnChange(item)}>{item[`${keyName}`]}</p>
                </div>
            ))}
        </div>}
    </div>
  )
}

export default Sort